import { inject } from "@angular/core";
import { Routes } from "@angular/router";
import { featureGuardAny, FeaturesService } from "@kno2/shared/features";
import { QueryHistoryComponent } from "./query/query-history.component";
import { queryGuard } from "./query/query.guard";
import { RequestHistoryComponent } from "./request/request-history.component";

export const routes: Routes = [
    {
        path: "records",
        loadComponent: () => import("./records.component").then((m) => m.RecordsComponent),
        children: [
            {
                path: "",
                redirectTo: () => {
                    const featuresService = inject(FeaturesService);

                    const hasQueryAccess = featuresService.isAnyEnabled(["CarequalityUI", "QhinQuery"]);

                    return hasQueryAccess ? "query" : "request";
                },
                pathMatch: "full"
            },
            {
                path: "request",
                component: RequestHistoryComponent
            },
            {
                path: "query",
                component: QueryHistoryComponent,
                canActivate: [featureGuardAny],
                data: {
                    features: ["CarequalityUI", "QhinQuery"]
                }
            }
        ]
    },
    {
        path: "records/request/new",
        loadComponent: () => import("./request/request.component").then((m) => m.RequestComponent)
    },
    {
        path: "records/query/new",
        loadComponent: () => import("./query/query.component").then((m) => m.QueryComponent),
        canActivate: [featureGuardAny],
        data: {
            features: ["CarequalityUI", "QhinQuery"]
        },
        children: [
            {
                path: "",
                loadComponent: () => import("./query/directory-search/query-directory-search.component").then((m) => m.QueryDirectorySearchComponent)
            },
            {
                path: "organizations",
                loadComponent: () => import("./query/organizations/query-organizations.component").then((m) => m.QueryOrganizationsComponent),
                canActivate: [queryGuard((queryService) => !!queryService.getorganizationQuery())]
            },
            {
                path: "patient",
                loadComponent: () => import("./query/patient-search/query-patient-search.component").then((m) => m.QueryPatientSearchComponent),
                canActivate: [queryGuard((queryService) => queryService.getSelectedOrganizations()?.length > 0 || queryService.isTefca())]
            },
            {
                path: "documents",
                loadComponent: () => import("./query/results/query-results.component").then((m) => m.QueryResultsComponent),
                canActivate: [queryGuard((queryService) => !!queryService.getPatientQuery())]
            }
        ]
    }
];
